var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 14.25C1.8375 14.25 1.48438 14.1031 1.19063 13.8094C0.896875 13.5156 0.75 13.1625 0.75 12.75V3H0V1.5H3.75V0.75H8.25V1.5H12V3H11.25V12.75C11.25 13.1625 11.1031 13.5156 10.8094 13.8094C10.5156 14.1031 10.1625 14.25 9.75 14.25H2.25ZM9.75 3H2.25V12.75H9.75V3ZM3.75 11.25H5.25V4.5H3.75V11.25ZM6.75 11.25H8.25V4.5H6.75V11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.53ae9627d5dfd7aa225871d2ca37c736.svg";
export { ForwardRef as ReactComponent };